module.exports = __webpack_public_path__ + "static/d-BBahena-72a9f47fcc15eeff6630ff04decb9512.jpg";